import React from 'react'

import { BookingFormProps } from '@cinch/oxd-components/booking-scheduler/src/components/booking-form/booking-form.component'
import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'

import BookingForm from './components/booking-form'

import * as styles from './booking-scheduler.module.css'

interface BookingSchedulerProps extends BookingFormProps {
  isLoading?: boolean
}

const BookingSchedulerPanel: React.FC<BookingSchedulerProps> = ({
  i18n,
  sites,
  onSiteSelect,
  onSubmit,
  onPostcodeChange,
  isLoading,
}) => {
  const showForm = sites && !!sites.length && !isLoading

  if (!showForm) {
    return (
      <div className={styles.loading}>
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <BookingForm
      i18n={i18n}
      sites={sites}
      onSiteSelect={onSiteSelect}
      onSubmit={onSubmit}
      onPostcodeChange={onPostcodeChange}
    />
  )
}

export default BookingSchedulerPanel
